<section class="error-page">
    <div class="container">
        <div class="row">
            <div class="col">
                <div class="error-section screen-reader"><img alt="Error Image - FCI" src="assets/images/404-error.png">
                    <div class="error-section__content">
                        <h5 class="screen-reader"> Page Not Found </h5>
                        <p class="screen-reader">Sorry, but we can't find what you were looking for right now.</p>
                        <p class="screen-reader">The content may have been removed, or is temporarily unavailable.</p>
                        <a href="" title="Home-FCI" class="screen-reader"> Home </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>